
;/*** Source: js/lib/loading.js ***/


(function($, $document, $window){
    
    
    var options = {
        tmpl        : '<div class="loading" ><div class="loading-icon" ></div></div>',
        container   : document.body,
        delay       : 200
    };
    
    
    $.fn.loading = function(opts){

        opts = $.extend({}, options, opts);
        
        var $tmpl = $(opts.tmpl);
        
        this.each(function(){
            
            var $this       = $(this),
                $loader     = $tmpl.clone(),
                zIndex      = Number( $this.css('zIndex') ),
                $container  = $( opts.container );
                        
            if(isNaN(zIndex))
                zIndex  = 10;
            else
                zIndex  = Math.max(1000, 1 + zIndex);
            
            
            if($this.width() === 0)
                return;
            
            $container.append( $loader.removeAttr('id').css({
                width       : $this.outerWidth()    || '100%',
                height      : $this.height()        || $tmpl.css('height'),
                position    : 'absolute',
                zIndex      : zIndex,
                top         : $this.offset().top - $container.offset().top,
                left        : $this.offset().left,
//                marginTop   : $this.css('marginTop')
            }) );
            
            $loader.attr('aria-loader-for', this.id);
            
            window.setTimeout(function($this){
                
                $this.addClass('in');
                
            }, opts.delay, $loader);
            
            $this.data('mnk-loader', $loader).one( 'loaded.mnk', function(){
                
                this.one('transitionend', function(){
                    
                    $(this).remove();
                    
                }).removeClass('in');
                
            }.bind($loader) );
            
            
        });    
        
    }

    
    
})(jQuery, jQuery(document), jQuery(window));
//